import webLogin from '@utils/weblogin.js';
import util from '@utils/util';
import Swiper from 'swiper';
import 'swiper/css/swiper.min.css';
import commonService from '@services/commonService';
import personalService from '@services/personalService';
import videoService from '@services/videoService';
import { getStyle, addClass, removeClass } from '@utils/dom';
import popupFans from './popupFans';
import popupFollow from './popupFollow';
import biggestFans from './biggestFans';
import personalVideo from './personalVideo';
import personalInfo from './personalInfo';
import liveVideo from './liveVideo';
function runOnceFn(fn, context) {
  // 控制让函数只触发一次
  return function () {
    try {
      // eslint-disable-next-line
      fn.apply(context || this, arguments);
    } catch (e) {
      console.log('runOnceFn', e);
    } finally {
      fn = null;
    }
  };
}
export default {
  name: 'personalContent',
  props: {
    countryCode: String,
    serverData: Object,
    personalid: String
  },
  data: function data() {
    return {
      PersonalAPIService: null,
      CommonAPIService: null,
      VideoAPIService: null,
      fansPop: 'none',
      // fans 弹窗 none/block
      followPop: 'none',
      // follow 弹窗 none/block

      replayVideo: false,
      // 是否是回播
      noData: true,
      // 没有数据
      loadingMask: true,
      // 加载弹层

      followAndFansPageIndex: 1,
      // follows fans 的页码
      followAndFansLoading: false,
      // 加载loading
      followAndFansNoMoreData: false,
      // follow 和 fans 没有更多数据

      bindList: [],
      // 绑定信息

      followingList: [],
      // following
      fansList: [],
      // fans
      biggestFansList: [],
      // biggest fans
      personalInfoList: {},
      //
      liveList: {},
      // live数据

      shortsVideo: true,
      // 是否是短视频
      shortsLoading: true,
      // 短视频加载中
      shortsPageIndex: 1,
      shorts_message_no_data: true,
      // 短视频
      shortsPopupListNoData: true,
      //
      shortsNoData: true,
      // 短视频列表没数据
      shortsNoMoreData: false,
      // 短视频列表没有更多数据

      feed_id: '',
      // 当前短视频的id
      shortsList: [],
      // 短视频数据
      shortsPopupList: {},
      // 短视频数据
      shortsCommentList: [],
      // 短视频评论
      shortsVid: '',
      // 当前短视频vid
      shortsMessageText: '',
      // 当前短视频的留言内容
      shortsSid: '',
      // 当前短视频的sid
      shortsCommentId: '',
      // 返回的最后一个comment_id 用于page翻页
      shortsGiftTop3: [],
      // 短视频GiftTop3
      isSelf: true,
      // 是否是自己
      disableWebp: false,
      // 用户信息
      userInfo: {},
      authentication: {},
      personalId: '',
      showShortsActive: false,
      isShortVideo: false,
      recommendList: [],
      tokenError: false,
      serverRender: false
    };
  },
  components: {
    popupFans: popupFans,
    popupFollow: popupFollow,
    biggestFans: biggestFans,
    personalVideo: personalVideo,
    personalInfo: personalInfo,
    liveVideo: liveVideo
  },
  methods: {
    clickClosePop: function clickClosePop(pop) {
      this[pop] = 'none';
      removeClass(document.body, 'overflowHidden');
    },
    clickShowPop: function clickShowPop(pop, index) {
      addClass(document.body, 'overflowHidden');
      this[pop] = 'block';
      this.followAndFansPageIndex = 1; // 点击就设置页码为1
      switch (pop) {
        case 'fansPop':
          this.followAndFansNoMoreData = false;
          this.getFans();
          break;
        case 'followPop':
          this.followAndFansNoMoreData = false;
          this.getFollowing();
          break;
        case 'shortsPop':
          this.shortsMessageText = '';
          this.shortsSid = util.getValue(this.shortsList[index], 'feed.sid', '');
          this.shortsCommentId = '';
          this.feed_id = util.getValue(this.shortsList[index], 'feed.feed_id', '');
          this.shortsVid = util.getValue(this.shortsList[index], 'feed.vid', '');
          this.shortsIndex = "".concat(index);
          this.shortsPopupList = "".concat(index) == '' ? [] : this.shortsList[index];
          this.getShortsPop("".concat(index));
          this.getCommentList({
            index: "".concat(index)
          });
          this.getGiftTop3();
          break;
        default:
          break;
      }
    },
    // 检测用户是否登录
    checkUserInfo: function checkUserInfo() {
      if (!webLogin.checkLogin()) {
        return null;
      }
      this.userInfo = webLogin.getUserInfoData().user;
      this.personalId = this.personalid || this.userInfo.uid || '';
      if (this.personalId == this.userInfo.uid) {
        this.isSelf = true;
      } else {
        this.isSelf = false;
      }
      return this.userInfo;
    },
    init: function init() {
      this.checkUserInfo(); // 非强制登录
      if (!this.userInfo) {
        this.noData = false;
        this.loadingMask = false;
        if (!this.personalId) {
          return;
        }
      } else {
        this.noData = false;
        this.loadingMask = false;
      }
      this.getPersonalInfo(); // 获取个人信息
      this.getBind(); // 用户绑定信息
      this.getBigFans(); // 获取biggestfans (好的)
      this.getLive(); // 获取直播状态 (好的)
      this.getVideoList(); // 视频播放列表（滚动加载
    },
    swiper: function swiper() {
      this.mySwiper = new Swiper('.swiper-container', {
        autoplay: 6000,
        // 间隔
        loop: true,
        // 循环播放
        autoplayDisableOnInteraction: false,
        // 用户触发之后不暂停
        paginationClickable: true,
        // 点击小按钮
        pagination: '.swiper-pagination' // 如果需要分页器
      });
    },
    // a连接 默认当前页面打开
    getLiveRoomLinkTarget: function getLiveRoomLinkTarget(target) {
      if (target) {
        return typeof target == 'boolean' ? '_black' : target;
      }
      return '';
    },
    // 点击关注好友
    clickFollowFriend: function clickFollowFriend(uid, type, index) {
      var self = this;
      if (!webLogin.checkLogin()) {
        return;
      }
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.subscribe(uid, self.authentication).then(function () {
        switch (type) {
          case 'fansPop':
            self.fansList[index].ship = 1;
            break;
          case 'followPop':
            self.followingList[index].ship = 1; // 因为不支持取消，所以可以固定
            break;
          case 'personal':
            self.personalInfoList.ship = 1;
            break;
          default:
            break;
        }
      }).catch(function (error) {
        // 网络错误 以及意外的错误处理
        console.info(error);
      });
    },
    // 视频播放列表（滚动加载）
    getVideoList: function getVideoList() {
      var para = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      self.shortsLoading = true;
      self.checkUserInfo();
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getVideoList(self.personalId, self.shortsPageIndex, 21, 10, '3.7.25', self.authentication).then(function (data) {
        self.shortsLoading = false;
        // eslint-disable-next-line no-plusplus
        self.shortsPageIndex++;
        var list = data.list || [];
        if (para.append) {
          if (list.length == 0) {
            self.shortsNoMoreData = true;
            return;
          }
          self.shortsList = self.shortsList.concat(list);
        } else {
          self.shortsList = list;
          if (self.shortsList.length == 0) {
            self.shortsNoData = true;
          } else {
            self.shortsNoData = false;
          }
        }
        self.scrollLoadShorts();
      }).catch(function (err) {
        self.shortsLoading = false;
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    getShortsPop: function getShortsPop(index) {
      this.shortsPopupList = this.shortsList[index];
      var commentNum = util.getValue(this.shortsPopupList, 'comment.count', 0);
      if (!commentNum || util.getValue(this.shortsPopupList, 'comment.list', []).length == 0) {
        this.shorts_message_no_data = true;
      } else {
        this.shorts_message_no_data = false;
      }
      if (!webLogin.checkLogin() || Number(index) < 0) {
        this.shortsPopupListNoData = true;
        this.shorts_message_no_data = true;
        return;
      }
      this.shortsPopupListNoData = false;
      this.shorts_message_no_data = false;
      this.shortsPopupList = this.shortsList[index];
      var likeNum = util.getValue(this.shortsPopupList, 'like.count', '');
      likeNum = Number(likeNum) > 1000 ? "".concat((Number(likeNum) / 1000).toFixed(1), "k") : likeNum;
      this.shortsPopupList.count = likeNum;
      this.player(util.getValue(this.shortsPopupList, 'feed.path', ''), util.getValue(this.shortsPopupList, 'feed.videocapture', ''), true);
      setTimeout(function () {
        var videoH = getStyle(document.querySelector('.popup-shorts .popup-container'), 'height');
        var elShortsVideo = document.querySelector('.shorts_video, video');
        elShortsVideo.style.width = "".concat(9 / 16 * videoH, "px");
        elShortsVideo.style.height = "".concat(videoH, "px");
        var elShortsMessage = document.querySelector('.shorts_message');
        elShortsMessage.style.position = 'absolute';
        elShortsMessage.style.left = "".concat(9 / 16 * videoH, "px");
        elShortsMessage.style.right = '0';
        elShortsMessage.style.height = "".concat(videoH, "px");
      }, 100);
    },
    // 绑定的个人信息
    getBind: function getBind() {
      var _this = this;
      var self = this;
      this.checkUserInfo();
      if (!self.PersonalAPIService) {
        return;
      }
      this.PersonalAPIService.getBindInfo(this.personalId, webLogin.getAuthentication()).then(function (data) {
        _this.bindList = data.bindInfo || [];
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    // following
    getFollowing: function getFollowing() {
      var para = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      if (!para.append) {
        setTimeout(function () {
          document.querySelector('.popup-box').scrollTop = 0;
        });
      }
      self.followAndFansLoading = true;
      self.checkUserInfo();
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getFollowingListShip(self.personalId, self.followAndFansPageIndex, 20, self.authentication).then(function (data) {
        self.followAndFansLoading = false;
        if (para.append) {
          if (data.length == 0) {
            self.followAndFansNoMoreData = true;
            return;
          }
          self.followingList = self.followingList.concat(data);
        } else {
          self.followingList = data;
        }
        // eslint-disable-next-line no-plusplus
        self.followAndFansPageIndex++;
      }).catch(function (err) {
        self.followAndFansLoading = false;
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    // fans
    getFans: function getFans() {
      var para = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      self.followAndFansLoading = true;
      if (!para.append) {
        setTimeout(function () {
          document.querySelector('.popup-box').scrollTop = 0;
        });
      }
      self.checkUserInfo();
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getFans(self.personalId, self.followAndFansPageIndex, 20, webLogin.getAuthentication()).then(function (data) {
        self.followAndFansLoading = false;
        if (para.append) {
          if (Array.isArray(data) && data.length == 0) {
            self.followAndFansNoMoreData = true;
            return;
          }
          self.fansList = self.fansList.concat(data);
        } else {
          self.fansList = data;
        }
        // eslint-disable-next-line no-plusplus
        self.followAndFansPageIndex++;
      }).catch(function (err) {
        self.followAndFansLoading = false;
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    // bigfans
    getBigFans: function getBigFans() {
      var self = this;
      this.checkUserInfo();
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getTopContribute(self.personalId, 1, 20, webLogin.getAuthentication()).then(function (data) {
        self.biggestFansList = data;
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    getCommentList: function getCommentList() {
      var para = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      para.feed_id = self.feed_id;
      if (!para.index || !para.feed_id) {
        return;
      }
      var userInfo = self.checkUserInfo();
      if (!userInfo) {
        return;
      }
      self.CommonAPIService.getCommentList(para.feed_id, webLogin.getAuthentication(), null, 10, 1).then(function (data) {
        // 暂时没加评论的分页，太坑了分页page不管用，居然要用上一次的记录的最后一个的comment_id
        self.shortsCommentList = (data.list || []).reverse();
        // eslint-disable-next-line no-plusplus
        for (var i = 0; i < self.shortsCommentList.length; i++) {
          // 换成格式 超过一年不显示，一年内的 10-24 20:50
          var nowdate = new Date();
          nowdate.setFullYear(nowdate.getFullYear() - 1);
          var lastYearStr = nowdate.getTime(); // 去年的时间戳
          var getStr = self.shortsCommentList[i].pubtime * 1000;
          if (getStr && getStr - lastYearStr > 0) {
            // TODO: - moment没有
          } else {
            self.shortsCommentList[i].publishTime = '';
          }
        }
        self.shortsCommentId = util.getValue(self.shortsCommentList[self.shortsCommentList.length - 1], 'comment_id', '');
        if (self.shortsCommentList.length == 0) {
          self.shorts_message_no_data = true;
        } else {
          self.shorts_message_no_data = false;
        }
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    getGiftTop3: function getGiftTop3() {
      var para = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var self = this;
      para.feed_id = self.feed_id;
      para.shortsVid = self.shortsVid;
      if (!para.feed_id || !para.shortsVid) {
        return;
      }
      if (!webLogin.checkLogin()) {
        return;
      }
      var giftid = '1049' || '992';
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getGiftTop3(para.shortsVid, para.feed_id, giftid, webLogin.getAuthentication()).then(function (data) {
        self.shortsGiftTop3 = data.list || [];
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    },
    // 当用户窗体比较大的时候，可能数据不够，让自动加数据
    scrollLoadShorts: function scrollLoadShorts() {
      if (this.shortsNoData || this.shortsNoMoreData) {
        return;
      }
      if (window.innerHeight >= getStyle(document.body, 'height') + 84 * 2) {
        this.getVideoList({
          append: true
        });
      } else {
        console.log('scrollLoadShorts');
      }
    },
    // 获取个人信息
    getPersonalInfo: function getPersonalInfo() {
      var _this2 = this;
      var self = this;
      this.checkUserInfo();
      if (!self.VideoAPIServic) {
        return;
      }
      self.VideoAPIService.getProfile(self.personalId, webLogin.getAuthentication()).then(function (data) {
        data.uid = util.getValue(data, 'user_info.uid', '');
        data.big_face = util.getValue(data, 'user_info.big_face', '');
        data.nickname = util.getValue(data, 'user_info.nickname', '');
        data.ship = util.getValue(data, 'user_info.is_relation', '') == 50001 || util.getValue(data, 'user_info.is_relation', '') == 50008 ? '1' : '0';
        data.usign = util.getValue(data, 'user_info.usign', '');
        data.sex = util.getValue(data, 'user_info.sex', '');
        data.addr = util.getValue(data, 'user_info.addr', '');
        data.impression = util.getValue(data, 'user_info.impression', []);
        data.poster = data.poster || [];
        data.follower_count = Number(util.getValue(data, 'count_info.follower_count', '0')) > 1000 ? "".concat((Number(util.getValue(data, 'count_info.follower_count', '0')) / 1000).toFixed(1), "k") : util.getValue(data, 'count_info.follower_count', '0');
        data.following_count = Number(util.getValue(data, 'count_info.following_count', '0')) > 1000 ? "".concat((Number(util.getValue(data, 'count_info.following_count', '0')) / 1000).toFixed(1), "k") : util.getValue(data, 'count_info.following_count', '0');
        self.personalInfoList = data;
        setTimeout(function () {
          self.swiper();
        }, 100);
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
        self.personalInfoList = {};
        // token登录过期
        if (util.getValue(err, 'data.msg') === 'token error') {
          self.tokenError = true;
          _this2.$lmBus && _this2.$lmBus.$emit('Header-Login-Out-Handle');
        }
      });
    },
    // 获取直播
    getLive: function getLive() {
      var self = this;
      if (!self.PersonalAPIService) {
        return;
      }
      self.PersonalAPIService.getLiveData(self.personalId).then(function (data) {
        self.liveList = data;
        setTimeout(function () {
          self.getLive(); // 轮训获取直播状态，
        }, 5000);
      }).catch(function (err) {
        // 网络错误 以及意外的错误处理
        console.log(err);
      });
    }
  },
  created: function created() {
    var _this3 = this;
    this.PersonalAPIService = personalService.createApi();
    this.VideoAPIService = videoService.createApi();
    this.CommonAPIService = commonService.createApi();
    this.personalId = this.personalid;
    if (this.serverData && this.serverData.status == '200') {
      this.noData = false;
      this.serverRender = true;
      this.liveList = this.serverData.data;
    }
    this.$lmBus && this.$lmBus.$on('Live-Login-Success-Handle', function (data) {
      if (data) {
        _this3.tokenError = false;
      }
    });
  },
  beforeMount: function beforeMount() {
    this.init();
    // 轮播
    this.swipeFire = runOnceFn(this.swiper);
    this.disableWebp = util.detctWebp(); // 是否支持canvas
    var resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
    var time;
    window.addEventListener(resizeEvt, function () {
      if (time) {
        clearTimeout(time);
      }
      time = setTimeout(function () {}, 200);
    }, false);
  },
  mounted: function mounted() {
    var self = this;
    var timer;
    if (window.history && window.history.pushState) {
      window.addEventListener('popstate', function () {
        Object.assign(self.$data, self.$options.data());
        self.init();
      });
    }
    var popupBoxs = document.querySelectorAll('.popup-box');
    popupBoxs.forEach(function (info) {
      info.addEventListener('scroll', function () {
        if (self.followAndFansLoading || self.followAndFansNoMoreData) {
          return;
        }
        var height = getStyle(info, 'height');
        var scrollTop = getStyle(info, 'scrollTop');
        var containTop = getStyle(info.querySelector('ul'), 'height');
        var type = info.dataset.type;
        if (timer) {
          clearTimeout(timer);
        }
        if (containTop < height + scrollTop + 80) {
          switch (type) {
            case 'fansPop':
              self.getFans({
                append: true
              });
              break;
            case 'followPop':
              self.getFollowing({
                append: true
              });
              break;
            case 'shortsPop':
              break;
            default:
              break;
          }
        }
      });
    });
  }
};